import { IResource } from "../i18n";

// tslint:disable-next-line: variable-name
const translation_de: IResource = {

    feedback_button_text: "Senden",
    feedback_cta_0_3: "Es tut uns wirklich Leid. Bitte teilen Sie uns mit, was wir beheben sollen",
    feedback_cta_4_6: "Bitte teilen Sie uns mit, was wir verbessern müssen?",
    feedback_cta_7_8: "Was können wir tun, um Meet besser zu machen?",
    feedback_cta_9_10: "Fantastisch! Können Sie uns sagen, das Ihnen am besten gefallen hat?",
    feedback_mail_subject: "Meet Sie das Feedback der Anwendung",
    feedback_text_legend: "Wir sind für konstruktives und positives Feedback gleichermaßen dankbar",
    feedback_text_title: "Geben Sie hier Ihr Feedback ab (optional)",
    feedback_title_finished: "Dein Meet ist beendet",
    feedback_title_ongoing: "Bitte helfen Sie uns, Meet zu verbessern",
    feedback_title_question: "Wie wahrscheinlich ist es, dass Sie Meet einem Freund oder Kollegen empfehlen?",
    feedback_value_best: "Sehr wahrscheinlich",
    feedback_value_worst: "Überhaupt nicht",

    onboarding_button_jointext: "Treten Sie Meet bei",
    onboarding_description_four: "Taste.",
    onboarding_description_one: "Als erstmaliger Benutzer können Sie anpassen, wie andere Sie in diesem Meeting sehen.",
    onboarding_description_three: "TRETE MEET bei",
    onboarding_description_two: "Sobald Sie fertig sind, klicken Sie einfach auf ",
    onboarding_label_color: "Farbe",
    onboarding_label_consentAgree: "Ich bin mit Meet einverstanden",
    onboarding_label_consentAnd: "und",
    onboarding_label_consentPrivacy: "Datenschutz-Bestimmungen",
    onboarding_label_consentTermsOfUse: "Nutzungsbedingungen",
    onboarding_label_darkTheme: "Dunkel",
    onboarding_label_firstName: "Ihr Name (optional)",
    onboarding_label_green: "Grün",
    onboarding_label_indigo: "Indigo",
    onboarding_label_lastName: "Ihr Nachname (optional)",
    onboarding_label_lightTheme: "Hell",
    onboarding_label_orange: "Orange",
    onboarding_label_pink: "Rosa",
    onboarding_label_purple: "Lila",
    onboarding_label_teal: "Blaugrün",
    onboarding_label_theme: "Design",
    onboarding_label_yellow: "Gelb",
    onboarding_title: "Freut mich, dich kennenzulernen!",

    invite_legend_text: "Senden Sie diesen Link an eine Person, die Sie anrufen möchten",
    invite_link_copy: "Link kopieren",
    invite_link_defaultCopied: "Link in die Zwischenablage kopiert!",
    invite_link_email: "E-Mail einladen",
    invite_link_label: "Ihre Einladungs-URL",
    invite_link_sms: "SMS einladen",
    invite_mail_body: "Hallo, bitte schließe dich meinem Meet an.",
    invite_mail_signature: "Grüße",
    invite_mail_subject: "Deine% 20wird% 20link% 20für% 20Meet &",
    invite_title_text: "LADE JEMAND ZU DEINEM MEET EIN",

    citypicker_label: "Stadt",
    citypicker_nomatch: "Keine passenden Standorte",

    userprofile_city_label: "Stadt",
    userprofile_color_label: "Farbe",
    userprofile_email_label: "E-Mail-Addresse",
    userprofile_label_green: "Grün",
    userprofile_label_indigo: "Indigo",
    userprofile_label_orange: "Orange",
    userprofile_label_pink: "Rosa",
    userprofile_label_purple: "Lila",
    userprofile_label_teal: "Blaugrün",
    userprofile_label_yellow: "Gelb",
    userprofile_locale_label: "Sprache",
    userprofile_name_label: "Vorname",
    userprofile_surname_label: "Nachname",
    userprofile_theme_label: "Design",
    userprofile_themedark_label: "Dunkel",
    userprofile_themelight_label: "Hell",

    options_tab_profile: "Profil",

    consentdialog_button_cancel: "Abbrechen",
    consentdialog_button_ok: "Meet beenden",

    layout_meet_end: "Meet beenden",
    layout_meet_leave: "Meet verlassen",

    layout_sidebar_labelClose: "Seitenleistenmenü schließen",
    layout_sidebar_labelOpen: "Seitenleistenmenü öffnen",
    layout_sidebar_labelTitle: "Seitenleistenmenü öffnen",
    layout_title_text: "Meet | Reibungslose Interviews",

    layout_toolbar_enter: "Vollbildmodus aktivieren",
    layout_toolbar_invite: "Einladen",
    layout_toolbar_invite_tooltip: "Laden Sie andere Leute zu diesem Meet ein",
    layout_toolbar_leave: "Vollbild verlassen",

    layout_dialog_descriptionEnd: "Damit endet das Meet für alle Teilnehmer",
    layout_dialog_titleEnd: "Möchten Sie dieses Meet wirklich beenden?",
    layout_dialog_titleLeave: "Möchten Sie dieses Meet wirklich verlassen?",

    layout_dialog_descriptionLeave: "Dies wird Meet für andere Teilnehmer NICHT beenden",
    layout_sidebar_explorer: "Hilfe",
    layout_sidebar_feedback: "Feedback teilen",
    layout_sidebar_settings: "Einstellungen",

    layout_finish_endmeet: "Beenden Sie die aktuelle Besprechung",
    layout_finish_leavemeet: "Verlasse die aktuelle Besprechung",

    layout_cta_register: "Brauchen Sie eine 60-minütige kostenlose Besprechung?",
    layout_cta_register_tooltip: "Melden Sie sich für ein kostenloses Guthaben von 10 $ an",

    layout_dialog_descriptionAbandon: "Es sieht so aus, als ob Sie der einzige sind, der telefoniert",
    layout_dialog_titleAbandon: "Möchten Sie dieses Meet beenden?",

    language_en_title: "English",
    language_srLatn_title: "Srpski",
    language_srCyrl_title: "Српски",
    language_fr_title: "Français",
    language_de_title: "Deutsche",
    language_es_title: "Español",
    language_it_title: "Italian",
    language_pl_title: "Polski",

    meeting_finished_title: "Interview abgeschlossen",
    meeting_finished_tooltip: "Schreibgeschützter",

    layout_reactivate_button: "Reaktivieren",
    layout_reactivate_tooltip: "Klicken Sie hier, wenn Sie dieses fertige Meet erneut öffnen und verwenden möchten",
    layout_dialog_titleReactivate: "Möchten Sie dieses Meet wirklich reaktivieren?",
    layout_dialog_descriptionReactivate: "Dadurch wird das Meet erneut geöffnet, damit Sie teilnehmen, es bearbeiten und andere Änderungen vornehmen können",
    toast_reconnecting_title: "Signalisierungsproblem aufrufen",
    toast_reconnecting_message: "Verbindung (status: {state}) aufgrund von Fehler {error} unterbrochen. Wiederverbindung ...",
    toast_reconnected_title: "Signalisierung aufrufen",
    toast_reconnected_message: "Verbindung wiederhergestellt. Status: {state}",
    toast_disconnected_title: "Signalisierungsfehler aufrufen",
    toast_disconnected_message: "Verbindung (status: {state}) wegen Fehler {error} geschlossen." +
                                 "Versuchen Sie, diese Seite zu aktualisieren, um die Verbindung neu zu starten.",

    config_title_text: "Erstellen Sie neue Meet",
    config_title_ctaOne: "Bitte definieren Sie die Elemente eines neuen Meet, den Sie erstellen möchten.",
    config_title_ctaTwo: "Alle Eingabedaten sind optional und können weggelassen werden.",
    config_title_label: "Titel",
    config_description_label: "Beschreibung",
    config_duration_label: "Dauer",
    config_tool_label: "Werkzeuge treffen",
    config_tool_call: "Videoanruf treffen",
    config_tool_editor: "Code-Editor",
    config_tool_whiteboard: "Whiteboard",
    config_passcode_label: "Meet passcode (falls vorhanden)",

    search_placeholder_text: "Geben Sie Suchkriterien ein",
    createMeeting_button_create: "Meet erstellen",

    projectboard_scheduleinfo_none: "Für das Meeting ist kein Startdatum definiert, sodass es jederzeit verwendet werden kann",
    projectboard_scheduleinfo_anytime: "Jederzeit",

    projectboard_join_anyone: "Jeder mit einem Link kann beitreten",
    projectboard_role_guest: "Gast",
    projectboard_role_interviewee: "Kandidat",
    projectboard_role_interviewer: "Interviewer",
    projectboard_role_organizer: "Veranstalter",

    projectboard_status_draft: "Im Entwurf",
    projectboard_status_scheduling: "Scheduling",
    projectboard_status_schedulingFailed: "Planung fehlgeschlagen",
    projectboard_status_pending: "steht aus",
    projectboard_status_ready: "Bereit",
    projectboard_status_starting: "Beginnend",
    projectboard_status_inprogress: "In Bearbeitung",
    projectboard_status_onhold: "In Wartestellung",
    projectboard_status_completed: "Abgeschlossen",
    projectboard_status_canceled: "Abgesagt",
    projectboard_status_archived: "Archiviert",
    projectboard_status_feedbackWait: "Warte auf Feedback",
    projectboard_status_feedbackDone: "Feedback gesammelt",
    projectboard_status_feedbackFail: "Feedbacksammlung fehlgeschlagen",

    projectboard_status_stopped: "Gestoppt",

    minibar_dashboard_title: "Instrumententafel",

    layout_sidebar_rateus: "Bewerten Sie uns",

    invite_passcode_label: "Passcode",

    invite_text_copy: "Kopieren laden",
    
    invite_text_body: "Bitte nehmen Sie an meinem Meet at teil {url}",
    
    invite_passcode_body: "Bitte treten Sie meinem Meet at {url} bei und verwenden Sie Passcode {passcode}",
    
    invite_text_copied: "Meet Invite Text wird in die Zwischenablage kopiert.",
    
    invite_pascode_add: "Passcode zur URL hinzufügen",
    
    participant_join_message: "Der Teilnehmer war an der Besprechung beigetreten.",
    participant_left_message: "Teilnehmer hatte die Besprechung verlassen.",

    minibar_dashboard_tooltip: "Verwalten Sie Ihre Interviews",

    layout_sidebar_snapshot: "schnappschuß",

    snapshots_none_text: "Erstellen Sie eine oder mehrere Schnappschüsse des Code-Editors und des Whiteboards, und überprüfen Sie sie nach dem Meet.",
    snapshots_cta_text: "Schnappschuss (F9) aufnehmen",
    snapshot_toast_text: "Schnappschuss gemacht",
    snapshot_sentiment_positive: "Positiver Schnappschuss",
    snapshot_sentiment_negative: "Negativer Schnappschuss",
    snapshot_sentiment_note: "Hinweis",
    
    snapshot_personal_value: "Persönlicher Schnappschuss",
    snapshot_personal_title: "Nur für dich sichtbar",
    snapshot_team_value: "Team-Snapshot",
    snapshot_team_title: "Nur für Ihr Team sichtbar.",
    snapshot_public_title: "Für alle Teilnehmer sichtbar",
    snapshot_public_value: "Öffentlicher Schnappschuss",

    snapshots_live_text: "Geh zurück zum Live-Meet",
    
    snapshot_action_delete: "Löschen",
    snapshot_action_load: "Snapshot laden",
    
    snapshot_delete_dialog_title: "Snapshot löschen?",
    snapshot_delete_dialog_description: "Bitte bestätigen Sie, dass Sie diesen Snapshot löschen möchten",
    snapshots_final_back: "Geh zurück zum Endzustand",
};

export default translation_de;
